import { AlertCircle, RotateCcw } from 'lucide-react-native';
import { Pressable } from 'react-native';
import { Box, Text } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

interface EnrichmentFailedActionsProps {
  onRetry?: () => void;
  onClose: () => void;
  errorMessage?: string;
}

export function EnrichmentFailedActions({
  onRetry,
  onClose,
  errorMessage,
}: Readonly<EnrichmentFailedActionsProps>) {
  const { t } = useTranslation();

  return (
    <>
      <AlertCircle size={40} color={colors.status.error.main} strokeWidth={1.5} />
      <Box
        backgroundColor={colors.status.error.bg}
        borderRadius="md"
        padding="lg"
        borderWidth={1}
        borderColor={colors.status.error.main}
        style={{ width: '100%', alignItems: 'center' }}
      >
        <Text variant="h6" color={colors.status.error.main} style={{ fontWeight: '600' }}>
          {t('leads.detail.enrichmentProgress.failed')}
        </Text>
        {errorMessage && (
          <Text variant="bodySmall" color={colors.text.secondary} style={{ marginTop: 8 }}>
            {errorMessage}
          </Text>
        )}
      </Box>
      {onRetry && (
        <Pressable
          onPress={onRetry}
          accessibilityRole="button"
          accessibilityLabel={t('leads.detail.enrichmentProgress.retry')}
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            gap: tokens.spacing.sm,
            backgroundColor: colors.primary[500],
            borderRadius: tokens.radius.md,
            paddingHorizontal: tokens.spacing.xl,
            paddingVertical: tokens.spacing.md,
          }}
        >
          <RotateCcw size={16} color={colors.primary[900]} strokeWidth={2} />
          <Text variant="body" color={colors.primary[900]} style={{ fontWeight: '600' }}>
            {t('leads.detail.enrichmentProgress.retry')}
          </Text>
        </Pressable>
      )}
      <Pressable
        onPress={onClose}
        accessibilityRole="button"
        accessibilityLabel={t('common.actions.close')}
      >
        <Text variant="bodySmall" color={colors.text.tertiary}>
          {t('common.actions.close')}
        </Text>
      </Pressable>
    </>
  );
}
